import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("pbh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;

export const getDashboard = () => client.get("/dashboard").then((r) => r.data);
export const getPatients = () => client.get("/patients").then((r) => r.data);
export const getPatient = (id) => client.get(`/patients/${id}`).then((r) => r.data);
export const createPatient = (data) => client.post("/patients", data).then((r) => r.data);
export const getSchedule = () => client.get("/schedule").then((r) => r.data);
export const getMessages = () => client.get("/messages").then((r) => r.data);
export const postMessage = (data) => client.post("/messages", data).then((r) => r.data);
export const getAssessments = () => client.get("/assessments").then((r) => r.data);
export const createAssessment = (data) => client.post("/assessments", data).then((r) => r.data);
export const getGoals = () => client.get("/treatment-plans").then((r) => r.data);
export const updateGoal = (id, data) => client.put(`/treatment-plans/${id}`, data).then((r) => r.data);
export const generateGoal = () => client.post("/treatment-plans/generate").then((r) => r.data);
export const getCoaching = () => client.get("/coaching").then((r) => r.data);
export const getInsights = () => client.get("/insights").then((r) => r.data);
export const getTrends = () => client.get("/analytics/trends").then((r) => r.data);
export const login = (data) => client.post("/auth/login", data).then((r) => r.data);
export const submitDemo = (data) => client.post("/demo-request", data).then((r) => r.data);

// ---- ProactiveClinics EHR integration ----
const PC = "/integrations/proactiveclinics";
const anyStatus = { validateStatus: () => true };
export const pcGetConfig = () => client.get(PC).then((r) => r.data);
export const pcConnect = (data) => client.post(PC, data, anyStatus);
export const pcTest = () => client.post(`${PC}/test`, null, anyStatus);
export const pcDisconnect = () => client.delete(PC).then((r) => r.data);
export const pcListPatients = (params) => client.get(`${PC}/patients`, { params, ...anyStatus });
export const pcCreatePatient = (data) => client.post(`${PC}/patients`, data, anyStatus);
export const pcListAppointments = (params) => client.get(`${PC}/appointments`, { params, ...anyStatus });
export const pcBookAppointment = (data) => client.post(`${PC}/appointments`, data, anyStatus);
export const pcListEncounters = (params) => client.get(`${PC}/encounters`, { params, ...anyStatus });
export const pcCreateEncounter = (data) => client.post(`${PC}/encounters`, data, anyStatus);
